import { useEffect, useState } from 'react';
import { BrowserAbilities } from 'javascripts/shared/utils/browser_abilities';

export function useOnScreen(ref) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  function getObserver() {
    if (BrowserAbilities.canUseIntersectionObservers()) {
      return new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      });
    }
    return {
      observe: _.noop,
      disconnect: _.noop,
    };
  }

  const observer = getObserver();

  useEffect(() => {
    if (!BrowserAbilities.canUseIntersectionObservers()) {
      setIsIntersecting(true);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
  }, [ref.current]);

  return isIntersecting;
}
